<template>
  <v-layout
    row
    wrap
    fluid
  >
    <v-flex>
      <v-card class="max-shadow">
        <v-card-title primary-title>
          <div class="headline">
            Edit {{ visitor.name }}
          </div>
        </v-card-title>
        <v-form ref="form">
          <v-container
            grid-list-lg
            fluid
            class="pa-3"
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  ref="name"
                  v-model="visitor.name"
                  :rules="[v => !!v || 'visitor Name is required']"
                  autofocus
                  label="Visitor Name"
                  required 
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  ref="email"
                  v-model="visitor.email"
                  :rules="validationRules.email"
                  label="Visitor Email"
                  type="email"
                  required
                  disabled 
                />
              </v-flex>
              <v-flex
                xs12
                sm6
                d-flex
                align-center
              >
                <div id="editVisPhone">
                  <v-text-field
                    ref="phone"
                    v-model="phoneFormatted"
                    :rules="validationRules.phone"
                    mask="##########"
                    label="Visitor Phone"
                    prefix="+91"
                    required
                  />
                </div>
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  ref="company"
                  v-model="visitor.company"
                  label="Company"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            flat
            @click.stop="$emit('cancel')"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click.stop="_saveVisitor"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :timeout="0"
        bottom
      >
        {{ snackbarMessage }}
        <v-btn
          flat
          @click.native="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
import _get from 'lodash/get';
import md5 from 'md5';

import validationRules from '@/mixins/validation-rules';
import { database } from '@/firebase';

export default {
  name: 'EditVisitor',
  mixins: [validationRules],
  props: {
    visitor: {
      type: Object,
      default: null,
      required: true
    }
  },
  data() {
    return {
      snackbarMessage: '',
      snackbarColor: 'primary',
      snackbar: false
    };
  },
  computed: {
    phoneFormatted: {
      get() {
        return _get(this.visitor, 'phone', '').replace('+91', '');
      },
      set(value) {
        this.visitor.phone = `+91${value}`;
      }
    },
    locationId() {
      return _get(this.$store.state.VMS, 'lid');
    }
  },
  methods: {
    _saveVisitor() {
      if (!this.$refs.form.validate()) return;

      const vis = this.visitor;
      vis.name = this.visitor.name.trim();
      vis.email = this.visitor.email.trim() || null;
      vis.company = this.visitor.company;

      if (vis.id) delete vis.id;

      const path = `vms/${this.locationId}/visitors/${md5(vis.phone)}`;
      database
        .ref(path)
        .set(vis)
        .catch(error => {
          this.snackbarMessage = error;
          this.snackbarColor = 'error';
          this.snackbar = true;
        });

      this.$emit('update');
    }
  }
};
</script>

